module.exports = __webpack_public_path__ + "img/historia21.cb4c12e9.jpg";